import { useNavigate, useParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { LiveStreamController } from "./live-stream-controller";
import { LiveStreamPage } from "./live-stream-page";

export function LiveStreamRoute({ deps }: { deps: AppDeps }) {
  const { streamId = "" } = useParams<{ streamId: string }>();
  const navigate = useNavigate();
  return (
    <Subtree
      key="live-stream"
      deps={[streamId]}
      controller={() =>
        new LiveStreamController(
          pick(
            deps,
            "client",
            "session",
            "authHandler",
            "storeRepository",
            "locationsRepository",
            "profileRepository",
            "broadcastStudio",
            "shareLinks",
          ),
          { streamId },
          { toStreams: () => navigate("/live") },
        )
      }
    >
      <LiveStreamPage />
    </Subtree>
  );
}
